import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import Clickable from '../../../../ui/Clickable';
import { $class } from '../../../../../utils';
import Icon from '../../../../ui/Icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';

const Nav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navButtons = [
    { icon: 'arr_right', name: 'Новые', counter: StagesStore.dataQueueList.length, route: 'new' },
    { icon: 'cake', name: 'В работе', counter: StagesStore.dataMyTasks.length, route: 'in-work' },
    { icon: 'user', name: 'Профиль', route: 'profile' },
    { icon: 'static', name: 'Статистика', route: 'stats' },
  ];

  const formatAmount = (amount: number) => {
    if (amount > 99) {
      return '99+';
    }
    return amount.toString();
  };

  return (
    <div className={styles.nav}>
      {navButtons.map((navButton) => (
        <Clickable
          key={navButton.name}
          className={$class(styles.navBtn, [
            styles.active,
            location.pathname.includes(navButton.route),
          ])}
          onClick={() => navigate(navButton.route)}
        >
          <Icon slug={navButton.icon} />
          {location.pathname.includes(navButton.route) && navButton.name}
          {!!navButton.counter && <b>{formatAmount(navButton.counter)}</b>}
        </Clickable>
      ))}
    </div>
  );
};

export default observer(Nav);
